import React, { useMemo, useRef, useEffect } from 'react';
import L from 'leaflet';
import { Marker, useMap } from 'react-leaflet';
import pinIcon from '../../../static/hoop-pin.svg';

const DraggableMarker = ({ markerPosition, onMarkerDrag }) => {
  const markerRef = useRef(null);
  const map = useMap();

  useEffect(() => {
    map.flyTo(markerPosition);
  }, [ markerPosition ]);

  const eventHandlers = useMemo(
    () => ({
      dragend() {
        const marker = markerRef.current;
        if (marker && marker !== null) {
          const nextMarkerPosition = marker.getLatLng();
          onMarkerDrag(nextMarkerPosition);
        }
      },
    }),
    [ onMarkerDrag ],
  );

  return (
    <Marker
      draggable
      eventHandlers={eventHandlers}
      position={markerPosition}
      icon={L.icon({ iconUrl: pinIcon, iconSize: [ 45, 50 ] })}
      ref={markerRef}
    />
  );
};

export default DraggableMarker;
